import styles from './ImageLink.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { ImageLinkProps } from '~types'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { fireAnalyticsEvent } from '~analyticsUtils'

import breakpoints from '../../../styles/breakpoints.json'
import { ConditionalWrapper } from '~elements'

const ImageLink = ({ imageXl, isTargetBlank = false, url, title }: ImageLinkProps) => {
  const { asPath } = useRouter()
  const fallbackImage = imageXl //In case to be needed update with other sizes
  const linkModule = 'image_link'
  const imageTitle = title || fallbackImage?.altText

  const analyticsClickHandler = () => {
    if (!url) return
    fireAnalyticsEvent(url, asPath, {
      linkModule: linkModule,
      clickTracking: `${linkModule}:${imageTitle}`
    })
  }

  return (
    <>
      <ConditionalWrapper
        wrapper={children => (
          <Link
            href={url!}
            target={isTargetBlank ? '_blank' : '_self'}
            className={styles.imageLink}
            onClick={analyticsClickHandler}
          >
            {children}
          </Link>
        )}
        condition={Boolean(url)}
      >
        <>
          {imageXl?.url && (
            <picture>
              {imageXl?.url && <source srcSet={imageXl.url} media={`(min-width: ${breakpoints.lg}px)`} />}
              {fallbackImage && (
                <Image
                  src={fallbackImage.url}
                  alt={fallbackImage?.altText ?? title ?? ''}
                  width={fallbackImage.width || 0}
                  height={fallbackImage.height || 0}
                  sizes='100vw'
                  quality={NEXT_IMAGE_QUALITY}
                  className={styles.imageLink}
                />
              )}
              {imageTitle && <div className='sr-only'>{imageTitle}</div>}
            </picture>
          )}
        </>
      </ConditionalWrapper>
    </>
  )
}

export default ImageLink
